import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "src/app/store/base.graphql";

export const sampleFormFields = `
id
sampleFormUniqueId
sampleFormTitle
sampleFormPath
`;

export const CREATE_SAMPLE_FORM = gql`
  mutation CreateServiceSampleFormMutation($input: SampleFormInputObject!) {
    createServiceSampleFormMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${sampleFormFields}
      }
    }
  }
`;

export const UPDATE_SAMPLE_FORM = gql`
  mutation UpdateServiceSampleFormMutation($input: SampleFormInputObject!) {
    updateServiceSampleFormMutation(input: $input) {
      data{
        ${sampleFormFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;

export const GET_ALL_SAMPLE_FORMS = gql`
  query GetServiceSampleForm($filtering: String) {
    getServiceSampleForm(formUniqueId: $filtering) {
      data{
        ${sampleFormFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;

export const DELETE_SAMPLE_FORM = gql`
  mutation DeleteServiceSampleFormMutation($sampleFormUniqueId: String!) {
    deleteServiceSampleFormMutation(sampleFormUniqueId: $sampleFormUniqueId) {
      response{
        ${baseResponse}
      }
    }
  }
`
// CITIZEN
export const CITIZEN_GET_SERVICE_SAMPLE_FORM = gql`
  query CitizenGetServiceSampleForm($formUniqueId: String) {
    citizenGetServiceSampleForm(formUniqueId: $formUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${sampleFormFields}
      }
    }
  }
`;
